<template>
  <div>
    <button-global type="neutral" text="RENAME" size="small" @eventPassed="renameButtonClicked"/>
  </div>
</template>

<script>
import {db} from '@/firebase'
import ButtonGlobal from '@/components/GlobalComponents/ButtonGlobal'

export default {
  name: "RenameEvent",
  props: {
    eventId: {
      required: true, 
      type: String
    },
    eventName: {
      required: true, 
      type: String
    }
  },
  components: {
    ButtonGlobal,
  },
  methods: {
    async renameButtonClicked() {
      const { value: newEventName } = await this.$swal({
        title: `Renaming: ${this.eventName}`,
        input: 'text',
        inputLabel: 'New event name',
        inputValue: this.eventName,
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return 'You need to write something!'
          }
        }
      })

      if (newEventName) {
        db.ref(`/customers/${this.$customerId}/events/${this.eventId}`)
          .set(newEventName)
          .then(() => {
            this.$swal(`Renamed ${this.eventName} to ${newEventName}`)
              .then(() => {
                window.location.reload()
              })
          })
      }
    }
  }
}
</script>
